import { useState } from "react";
import "./MenuBottom.css";
/* Code generated with AutoHTML Plugin for Figma */
import Active from "../../assets/taiga-uikit/icons/additem.svg?react";
import Clock from "../../assets/taiga-uikit/icons/clock.svg?react";
import DocumentCopy from "../../assets/taiga-uikit/icons/document-copy.svg?react";
import Edit from "../../assets/taiga-uikit/icons/edit.svg?react";
import Frame from "../../assets/taiga-uikit/icons/profile.svg?react";

import OrderSvg from "../../assets/taiga-uikit/icons/document-text.svg?react";
import ChatSvg from "../../assets/taiga-uikit/icons/messages-3.svg?react";
import NoteAddSvg from "../../assets/taiga-uikit/icons/note-add.svg?react";
import WaitSvg from "../../assets/taiga-uikit/icons/task-square.svg?react";
import ProfileSvg from "../../assets/taiga-uikit/icons/user-octagon.svg?react";

import { _colorText, _size } from "../../core/core";
import { _client_urls } from "../../core/core_client";
import KeyboardAware from "../../hooks/KeyboardAware";
import { useNotificationCount } from "../../hooks/useNotificationCount";
import { Stepper } from "../Stepper/Stepper";
import { MenuBottomLink } from "./MenuLink";

const _modalType = { off: null, menu: "menu", button: "button", help: "help" };
export const MenuBottom = ({ is_client = false }) => {
  const [modalType] = useState(_modalType.off);
  const [isKeyboardOpen] = KeyboardAware();
  const page = window.location.href;

  const getClassName = (link: string) => {
    return page.includes(link)
      ? "button-menu button-menu-hover"
      : "button-menu";
  };
  return (
    <div className={`menu-bottom-fix menu-animate-${isKeyboardOpen}`}>
      <div className={`tab-bar-menu tab-${modalType}`}>
        <div className="button-groups">
          {is_client ? (
            <>
              <MenuBottomLink
                title={"Создать"}
                link={_client_urls.create}
                icon={<NoteAddSvg />}
                className={
                  page === "/" ? "button-menu button-menu-hover" : "button-menu"
                }
              />
              <MenuBottomLink
                title={"Заказы"}
                link={_client_urls.orders}
                icon={<OrderSvg />}
                className={getClassName("/client/orders/")}
              />
              <MenuBottomLink
                title={"Обзор"}
                link={_client_urls.dash}
                icon={<WaitSvg />}
                className={getClassName("/wait/")}
              ></MenuBottomLink>
              <MenuBottomLink
                title={"Чат"}
                link={_client_urls.chat}
                icon={<ChatSvg />}
                className={getClassName("/close/")}
              ></MenuBottomLink>
              <MenuBottomLink
                title={"Профиль"}
                link={_client_urls.profile}
                icon={<ProfileSvg />}
                className={getClassName("/client/profile/")}
              ></MenuBottomLink>
            </>
          ) : (
            <>
              {<ExecutorMenuButtons page={page} getClassName={getClassName} />}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const ExecutorMenuButtons = ({
  page,
  getClassName,
}: {
  page: string;
  getClassName: (link: string) => string;
}) => {
  const { note } = useNotificationCount();
  return (
    <>
      <MenuBottomLink
        title={"Задания"}
        link="/find/"
        icon={<Active />}
        className={
          page === "/" ? "button-menu button-menu-hover" : "button-menu"
        }
      />
      <MenuBottomLink
        title={"В работе"}
        link="/work/"
        icon={<Edit />}
        className={getClassName("/work/")}
      >
        {note.isWork && (
          <Stepper
            color={_colorText.positive}
            size={_size.XS}
            active
            top="-16px"
            left="13px"
          />
        )}
      </MenuBottomLink>
      <MenuBottomLink
        title={"На проверке"}
        link="/wait/"
        icon={<Clock />}
        className={getClassName("/wait/")}
      >
        {note.isWait && (
          <Stepper
            color={_colorText.positive}
            size={_size.XS}
            active
            top="-16px"
            left="13px"
          />
        )}
      </MenuBottomLink>
      <MenuBottomLink
        title={"Архив"}
        link="/close/"
        icon={<DocumentCopy />}
        className={getClassName("/close/")}
      >
        {note.isClose && (
          <Stepper
            color={_colorText.positive}
            size={_size.XS}
            active
            top="-16px"
            left="13px"
          />
        )}
      </MenuBottomLink>
      <MenuBottomLink
        title={"Профиль"}
        link="/authorize/user/"
        icon={<Frame />}
        className={getClassName("/authorize/")}
      >
        {note.isClose && (
          <Stepper
            color={_colorText.positive}
            size={_size.XS}
            active
            top="-16px"
            left="13px"
          />
        )}
      </MenuBottomLink>
    </>
  );
};
